import { useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import Resort from "../models/Resort"
import queryKeys from "../queryKeys"

const useResorts = () => {
  //const currentCulture = useSkipassStore((state) => state.currentCulture)
  return useQuery<Resort[]>({
    queryKey: queryKeys.resorts,
    queryFn: async () => {
      const res = await bffApi.get<{ resorts: Resort[] }>("/resorts")
      return res.data.resorts
    },
    staleTime: Infinity, // Resorts rarely change, so we can cache them indefinitely
  })
}

export default useResorts
